import pegasus from './01-pegasus.js';

//Request a call back model links
document.addEventListener('DOMContentLoaded', function() {
    const links = document.querySelectorAll('a[href*="request-a-call-back"]');
    links.forEach(link => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            const customEvent = new CustomEvent('opencallback');
            window.dispatchEvent(customEvent);
        });
    });
});

//Init cloudflare email decoder (Cloudflare obfuscates emails for protection)
document.addEventListener('DOMContentLoaded', function() {
    pegasus.decodeAllCloudflareEmails();
});